export default __webpack_public_path__ + "assets/lernzentrum.1a91778.jpg";